import axios from 'axios';

const axiosInstance = axios.create({
   baseURL: 'https://services-staging-internal.classkick.com/',
   headers: {
      'Content-Type': 'application/json',
   }
});

export default axiosInstance;
